/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/10
 */

import request from 'crm/utils/request'
import api from 'crm/common/api/tree'

export async function tree() {
    return request(`${api.tree.url}`)
}
